// PostFeed.js
import { connect } from 'react-redux';
import _ from 'lodash';

import setScrollerPositionData from '../action/setScrollerPositionData.js';
import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';
import setMessageHeightInFeed from '../action/setMessageHeightInFeed.js';

import getListData from '../selector/getListData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';

import PostFeed from '../component/PostFeed.jsx';

import { FOLLOWING_PREFETCHED_MESSAGE_AMOUNT } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { category }) => {
  const feedType = getReturnType({ feedName: category });
  const selectPath = ['home', feedType, category];
  const nextPage = getListData(state, selectPath, 'nextPage');
  return {
    prefetchedMessageAmount: getRemoteConfigData(
      state,
      FOLLOWING_PREFETCHED_MESSAGE_AMOUNT
    ),
    postIds: getListData(state, selectPath, 'itemIds'),
    meId: getMeData(state, 'id'),
    currentAutoplayPostId: getOperationData(
      state,
      ['feed'],
      'currentAutoplayPostId'
    ),
    isNextPageFetching: !!getNetworkingData(
      state,
      [...selectPath, nextPage],
      'isFetching'
    ),
    isFirstPageFetching: !!getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetching'
    ),
    isFirstPageFetched: !!getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetched'
    ),
    nextPage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
    setScrollerPositionData: _.debounce(
      ({ scrollerPositionData, page }) =>
        dispatch(setScrollerPositionData({ scrollerPositionData, page })),
      50
    ),
    setMessageHeightInFeed: ({ feedName, messageObject }) =>
      dispatch(
        setMessageHeightInFeed({
          feedName,
          messageObject,
        })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostFeed);
